"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "Address", {
  enumerable: true,
  get: function () {
    return _address.default;
  }
});
Object.defineProperty(exports, "AnalyzeResponse", {
  enumerable: true,
  get: function () {
    return _slide4.default;
  }
});
Object.defineProperty(exports, "Betastatus", {
  enumerable: true,
  get: function () {
    return _Betastatus.default;
  }
});
Object.defineProperty(exports, "Calculation", {
  enumerable: true,
  get: function () {
    return _calculations.default;
  }
});
Object.defineProperty(exports, "CheckBox", {
  enumerable: true,
  get: function () {
    return _checkbox.default;
  }
});
Object.defineProperty(exports, "Clock", {
  enumerable: true,
  get: function () {
    return _clock.default;
  }
});
Object.defineProperty(exports, "Currency", {
  enumerable: true,
  get: function () {
    return _currency.default;
  }
});
Object.defineProperty(exports, "DashboardLogo", {
  enumerable: true,
  get: function () {
    return _Frame.default;
  }
});
Object.defineProperty(exports, "DataSecurity", {
  enumerable: true,
  get: function () {
    return _lucide_lock.default;
  }
});
Object.defineProperty(exports, "DatePicker", {
  enumerable: true,
  get: function () {
    return _datePicker.default;
  }
});
Object.defineProperty(exports, "Dates", {
  enumerable: true,
  get: function () {
    return _date.default;
  }
});
Object.defineProperty(exports, "Decimal", {
  enumerable: true,
  get: function () {
    return _decimal.default;
  }
});
Object.defineProperty(exports, "DecisionBox", {
  enumerable: true,
  get: function () {
    return _decisionbox.default;
  }
});
Object.defineProperty(exports, "DetailsIcon", {
  enumerable: true,
  get: function () {
    return _DetailsIcon.default;
  }
});
Object.defineProperty(exports, "Dropdown", {
  enumerable: true,
  get: function () {
    return _dropdown.default;
  }
});
Object.defineProperty(exports, "FieldTypes", {
  enumerable: true,
  get: function () {
    return _slide2.default;
  }
});
Object.defineProperty(exports, "Fileupload", {
  enumerable: true,
  get: function () {
    return _fileupload.default;
  }
});
Object.defineProperty(exports, "FormBuilderImage", {
  enumerable: true,
  get: function () {
    return _formbuilderpage.default;
  }
});
Object.defineProperty(exports, "FormSettings", {
  enumerable: true,
  get: function () {
    return _slide3.default;
  }
});
Object.defineProperty(exports, "HeaderAvatar", {
  enumerable: true,
  get: function () {
    return _Avatar.default;
  }
});
Object.defineProperty(exports, "HeaderLogo", {
  enumerable: true,
  get: function () {
    return _munshifyLogo.default;
  }
});
Object.defineProperty(exports, "HeartIcon", {
  enumerable: true,
  get: function () {
    return _heart.default;
  }
});
Object.defineProperty(exports, "Mail", {
  enumerable: true,
  get: function () {
    return _email.default;
  }
});
Object.defineProperty(exports, "MultiChoice", {
  enumerable: true,
  get: function () {
    return _multichoice.default;
  }
});
Object.defineProperty(exports, "Multiline", {
  enumerable: true,
  get: function () {
    return _multiline.default;
  }
});
Object.defineProperty(exports, "Name", {
  enumerable: true,
  get: function () {
    return _name.default;
  }
});
Object.defineProperty(exports, "NextImage", {
  enumerable: true,
  get: function () {
    return _next.default;
  }
});
Object.defineProperty(exports, "Number", {
  enumerable: true,
  get: function () {
    return _number.default;
  }
});
Object.defineProperty(exports, "PageBreak", {
  enumerable: true,
  get: function () {
    return _pagebreak.default;
  }
});
Object.defineProperty(exports, "Pause", {
  enumerable: true,
  get: function () {
    return _Pause.default;
  }
});
Object.defineProperty(exports, "Payment", {
  enumerable: true,
  get: function () {
    return _payment.default;
  }
});
Object.defineProperty(exports, "Phone", {
  enumerable: true,
  get: function () {
    return _phone.default;
  }
});
Object.defineProperty(exports, "Rating", {
  enumerable: true,
  get: function () {
    return _rating.default;
  }
});
Object.defineProperty(exports, "Section", {
  enumerable: true,
  get: function () {
    return _section.default;
  }
});
Object.defineProperty(exports, "Singleline", {
  enumerable: true,
  get: function () {
    return _singleline.default;
  }
});
Object.defineProperty(exports, "Slider", {
  enumerable: true,
  get: function () {
    return _slider.default;
  }
});
Object.defineProperty(exports, "Time", {
  enumerable: true,
  get: function () {
    return _time.default;
  }
});
Object.defineProperty(exports, "TimerClock", {
  enumerable: true,
  get: function () {
    return _TimerClock.default;
  }
});
Object.defineProperty(exports, "Website", {
  enumerable: true,
  get: function () {
    return _website.default;
  }
});
Object.defineProperty(exports, "WelcomeToFormBuilder", {
  enumerable: true,
  get: function () {
    return _slide.default;
  }
});
Object.defineProperty(exports, "XIcon", {
  enumerable: true,
  get: function () {
    return _xIcon.default;
  }
});
Object.defineProperty(exports, "accessFeatures", {
  enumerable: true,
  get: function () {
    return _accessFeatures.default;
  }
});
Object.defineProperty(exports, "activeRating", {
  enumerable: true,
  get: function () {
    return _activeRating.default;
  }
});
Object.defineProperty(exports, "avatar", {
  enumerable: true,
  get: function () {
    return _avatar.default;
  }
});
Object.defineProperty(exports, "betaversion", {
  enumerable: true,
  get: function () {
    return _Frame2.default;
  }
});
Object.defineProperty(exports, "cancelIcon", {
  enumerable: true,
  get: function () {
    return _cancel.default;
  }
});
Object.defineProperty(exports, "cardTooltip", {
  enumerable: true,
  get: function () {
    return _cardTooltip.default;
  }
});
Object.defineProperty(exports, "changeIcon", {
  enumerable: true,
  get: function () {
    return _change.default;
  }
});
Object.defineProperty(exports, "chevDown", {
  enumerable: true,
  get: function () {
    return _chevDown.default;
  }
});
Object.defineProperty(exports, "chevUp", {
  enumerable: true,
  get: function () {
    return _chevUp.default;
  }
});
Object.defineProperty(exports, "chipClose", {
  enumerable: true,
  get: function () {
    return _chipClose.default;
  }
});
Object.defineProperty(exports, "collapseFolder", {
  enumerable: true,
  get: function () {
    return _collapseFolder.default;
  }
});
Object.defineProperty(exports, "component", {
  enumerable: true,
  get: function () {
    return _component.default;
  }
});
Object.defineProperty(exports, "createRole", {
  enumerable: true,
  get: function () {
    return _createRole.default;
  }
});
Object.defineProperty(exports, "csv", {
  enumerable: true,
  get: function () {
    return _csv.default;
  }
});
Object.defineProperty(exports, "databaseIcon", {
  enumerable: true,
  get: function () {
    return _majesticons_dataLine.default;
  }
});
Object.defineProperty(exports, "deleteIcon", {
  enumerable: true,
  get: function () {
    return _delete.default;
  }
});
Object.defineProperty(exports, "docTypeIcon", {
  enumerable: true,
  get: function () {
    return _wordTypeIcon.default;
  }
});
Object.defineProperty(exports, "doubletick", {
  enumerable: true,
  get: function () {
    return _doubletick.default;
  }
});
Object.defineProperty(exports, "downSvg", {
  enumerable: true,
  get: function () {
    return _down.default;
  }
});
Object.defineProperty(exports, "download", {
  enumerable: true,
  get: function () {
    return _download.default;
  }
});
Object.defineProperty(exports, "downloadTypeIcon", {
  enumerable: true,
  get: function () {
    return _downloadTypeIcon.default;
  }
});
Object.defineProperty(exports, "edit", {
  enumerable: true,
  get: function () {
    return _edit.default;
  }
});
Object.defineProperty(exports, "editData", {
  enumerable: true,
  get: function () {
    return _editData.default;
  }
});
Object.defineProperty(exports, "emptyNotification", {
  enumerable: true,
  get: function () {
    return _emptyNotification.default;
  }
});
Object.defineProperty(exports, "excel", {
  enumerable: true,
  get: function () {
    return _excel.default;
  }
});
Object.defineProperty(exports, "excelTypeIcon", {
  enumerable: true,
  get: function () {
    return _excelTypeIcon.default;
  }
});
Object.defineProperty(exports, "expandFolder", {
  enumerable: true,
  get: function () {
    return _expandFolder.default;
  }
});
Object.defineProperty(exports, "eyeIcon", {
  enumerable: true,
  get: function () {
    return _eyeIcon.default;
  }
});
Object.defineProperty(exports, "feedback", {
  enumerable: true,
  get: function () {
    return _feedback.default;
  }
});
Object.defineProperty(exports, "fieldIcon", {
  enumerable: true,
  get: function () {
    return _fieldIcon.default;
  }
});
Object.defineProperty(exports, "fileUpload", {
  enumerable: true,
  get: function () {
    return _fileUploadIcon.default;
  }
});
Object.defineProperty(exports, "folderPlus", {
  enumerable: true,
  get: function () {
    return _folderPlus.default;
  }
});
Object.defineProperty(exports, "formIcon", {
  enumerable: true,
  get: function () {
    return _formIcon.default;
  }
});
Object.defineProperty(exports, "formsIcon", {
  enumerable: true,
  get: function () {
    return _formsIcon.default;
  }
});
Object.defineProperty(exports, "greenAddIcon", {
  enumerable: true,
  get: function () {
    return _greenAddIcon.default;
  }
});
Object.defineProperty(exports, "image", {
  enumerable: true,
  get: function () {
    return _images.default;
  }
});
Object.defineProperty(exports, "imageTypeIcon", {
  enumerable: true,
  get: function () {
    return _imageTypeIcon.default;
  }
});
Object.defineProperty(exports, "inActiveRating", {
  enumerable: true,
  get: function () {
    return _inActiveRating.default;
  }
});
Object.defineProperty(exports, "info", {
  enumerable: true,
  get: function () {
    return _info.default;
  }
});
Object.defineProperty(exports, "kanbanIcon", {
  enumerable: true,
  get: function () {
    return _KanbanIcon.default;
  }
});
Object.defineProperty(exports, "kanbanNodata", {
  enumerable: true,
  get: function () {
    return _kanbanNodata.default;
  }
});
Object.defineProperty(exports, "keyboardIcon", {
  enumerable: true,
  get: function () {
    return _keyboardIcon.default;
  }
});
Object.defineProperty(exports, "lock", {
  enumerable: true,
  get: function () {
    return _lock.default;
  }
});
Object.defineProperty(exports, "mail", {
  enumerable: true,
  get: function () {
    return _email.default;
  }
});
Object.defineProperty(exports, "mailIcon", {
  enumerable: true,
  get: function () {
    return _mailIcon.default;
  }
});
Object.defineProperty(exports, "menuIcon", {
  enumerable: true,
  get: function () {
    return _menu_icon.default;
  }
});
Object.defineProperty(exports, "minusIcon", {
  enumerable: true,
  get: function () {
    return _minusCircle.default;
  }
});
Object.defineProperty(exports, "minusSign", {
  enumerable: true,
  get: function () {
    return _minusIcon.default;
  }
});
Object.defineProperty(exports, "moreInfoIcon", {
  enumerable: true,
  get: function () {
    return _moreinfoicon.default;
  }
});
Object.defineProperty(exports, "moreOptions", {
  enumerable: true,
  get: function () {
    return _moreOptions.default;
  }
});
Object.defineProperty(exports, "newDownload", {
  enumerable: true,
  get: function () {
    return _newDownload.default;
  }
});
Object.defineProperty(exports, "notification", {
  enumerable: true,
  get: function () {
    return _bellNotifications.default;
  }
});
Object.defineProperty(exports, "nouserInApplication", {
  enumerable: true,
  get: function () {
    return _nouserInApplication.default;
  }
});
Object.defineProperty(exports, "outline", {
  enumerable: true,
  get: function () {
    return _mdi_thunderOutline.default;
  }
});
Object.defineProperty(exports, "page", {
  enumerable: true,
  get: function () {
    return _page.default;
  }
});
Object.defineProperty(exports, "pageIcon", {
  enumerable: true,
  get: function () {
    return _pageIcon.default;
  }
});
Object.defineProperty(exports, "pauseIcon", {
  enumerable: true,
  get: function () {
    return _pauseIcon.default;
  }
});
Object.defineProperty(exports, "pdf", {
  enumerable: true,
  get: function () {
    return _pdf.default;
  }
});
Object.defineProperty(exports, "pdfTypeIcon", {
  enumerable: true,
  get: function () {
    return _pdfTypeIcon.default;
  }
});
Object.defineProperty(exports, "phoneIcon", {
  enumerable: true,
  get: function () {
    return _phoneIcon.default;
  }
});
Object.defineProperty(exports, "phoneImage", {
  enumerable: true,
  get: function () {
    return _phone.default;
  }
});
Object.defineProperty(exports, "playIcon", {
  enumerable: true,
  get: function () {
    return _playIcon.default;
  }
});
Object.defineProperty(exports, "plusIcon", {
  enumerable: true,
  get: function () {
    return _plusCircle.default;
  }
});
Object.defineProperty(exports, "plusSign", {
  enumerable: true,
  get: function () {
    return _plusIcon.default;
  }
});
Object.defineProperty(exports, "powerpoint", {
  enumerable: true,
  get: function () {
    return _powerpoint.default;
  }
});
Object.defineProperty(exports, "pptTypeIcon", {
  enumerable: true,
  get: function () {
    return _pptTypeIcon.default;
  }
});
Object.defineProperty(exports, "profile", {
  enumerable: true,
  get: function () {
    return _profile.default;
  }
});
Object.defineProperty(exports, "redLockIcon", {
  enumerable: true,
  get: function () {
    return _RedLockIcon.default;
  }
});
Object.defineProperty(exports, "redMinusIcon", {
  enumerable: true,
  get: function () {
    return _redMinusIcon.default;
  }
});
Object.defineProperty(exports, "resetIcon", {
  enumerable: true,
  get: function () {
    return _resetIcon.default;
  }
});
Object.defineProperty(exports, "rightArrow", {
  enumerable: true,
  get: function () {
    return _rightArrow.default;
  }
});
Object.defineProperty(exports, "rightIcon", {
  enumerable: true,
  get: function () {
    return _rightIcon.default;
  }
});
Object.defineProperty(exports, "saveRightIcon", {
  enumerable: true,
  get: function () {
    return _saveRightIcon.default;
  }
});
Object.defineProperty(exports, "searchSvg", {
  enumerable: true,
  get: function () {
    return _searchData.default;
  }
});
Object.defineProperty(exports, "sectionIcon", {
  enumerable: true,
  get: function () {
    return _sectionIcon.default;
  }
});
Object.defineProperty(exports, "selected", {
  enumerable: true,
  get: function () {
    return _selected.default;
  }
});
Object.defineProperty(exports, "settings", {
  enumerable: true,
  get: function () {
    return _settings.default;
  }
});
Object.defineProperty(exports, "signout", {
  enumerable: true,
  get: function () {
    return _signOut.default;
  }
});
Object.defineProperty(exports, "sortDown", {
  enumerable: true,
  get: function () {
    return _sortDown.default;
  }
});
Object.defineProperty(exports, "sortUp", {
  enumerable: true,
  get: function () {
    return _sortUp.default;
  }
});
Object.defineProperty(exports, "statusIcon", {
  enumerable: true,
  get: function () {
    return _statusCircal.default;
  }
});
Object.defineProperty(exports, "successIcon", {
  enumerable: true,
  get: function () {
    return _successIcon.default;
  }
});
Object.defineProperty(exports, "supportIcon", {
  enumerable: true,
  get: function () {
    return _supportIcon.default;
  }
});
Object.defineProperty(exports, "tableAdvancedFilters", {
  enumerable: true,
  get: function () {
    return _filterIcon.default;
  }
});
Object.defineProperty(exports, "tableAdvancedFiltersV1", {
  enumerable: true,
  get: function () {
    return _filterLineIcon.default;
  }
});
Object.defineProperty(exports, "tableHeadMod", {
  enumerable: true,
  get: function () {
    return _tableHeadMod.default;
  }
});
Object.defineProperty(exports, "tableIcon", {
  enumerable: true,
  get: function () {
    return _tableIcon.default;
  }
});
Object.defineProperty(exports, "tableMoreIcon", {
  enumerable: true,
  get: function () {
    return _tableMore.default;
  }
});
Object.defineProperty(exports, "tableSearchIcon", {
  enumerable: true,
  get: function () {
    return _searchIcon.default;
  }
});
Object.defineProperty(exports, "updatesIcon", {
  enumerable: true,
  get: function () {
    return _updatesIcon.default;
  }
});
Object.defineProperty(exports, "uploadIcon", {
  enumerable: true,
  get: function () {
    return _upload.default;
  }
});
Object.defineProperty(exports, "uploadProfile", {
  enumerable: true,
  get: function () {
    return _uploadProfile.default;
  }
});
Object.defineProperty(exports, "viewMoreTabs", {
  enumerable: true,
  get: function () {
    return _viewMoreTab.default;
  }
});
Object.defineProperty(exports, "world", {
  enumerable: true,
  get: function () {
    return _world.default;
  }
});
Object.defineProperty(exports, "xIcons", {
  enumerable: true,
  get: function () {
    return _xIcon.default;
  }
});
var _munshifyLogo = _interopRequireDefault(require("./Images/munshifyLogo.png"));
var _Frame = _interopRequireDefault(require("./Images/Frame.png"));
var _singleline = _interopRequireDefault(require("./Images/singleline.svg"));
var _multiline = _interopRequireDefault(require("./Images/multiline.svg"));
var _number = _interopRequireDefault(require("./Images/number.svg"));
var _decimal = _interopRequireDefault(require("./Images/decimal.svg"));
var _address = _interopRequireDefault(require("./Images/address.svg"));
var _calculations = _interopRequireDefault(require("./Images/calculations.svg"));
var _checkbox = _interopRequireDefault(require("./Images/checkbox.svg"));
var _date = _interopRequireDefault(require("./Images/date.svg"));
var _currency = _interopRequireDefault(require("./Images/currency.svg"));
var _decisionbox = _interopRequireDefault(require("./Images/decisionbox.svg"));
var _dropdown = _interopRequireDefault(require("./Images/dropdown.svg"));
var _fileupload = _interopRequireDefault(require("./Images/fileupload.svg"));
var _email = _interopRequireDefault(require("./Images/email.svg"));
var _multichoice = _interopRequireDefault(require("./Images/multichoice.svg"));
var _name = _interopRequireDefault(require("./Images/name.svg"));
var _pagebreak = _interopRequireDefault(require("./Images/pagebreak.svg"));
var _payment = _interopRequireDefault(require("./Images/payment.svg"));
var _rating = _interopRequireDefault(require("./Images/rating.svg"));
var _phone = _interopRequireDefault(require("./Images/phone.svg"));
var _section = _interopRequireDefault(require("./Images/section.svg"));
var _slider = _interopRequireDefault(require("./Images/slider.svg"));
var _time = _interopRequireDefault(require("./Images/time.svg"));
var _website = _interopRequireDefault(require("./Images/website.svg"));
var _mailIcon = _interopRequireDefault(require("./Images/mailIcon.svg"));
var _phoneIcon = _interopRequireDefault(require("./Images/phoneIcon.svg"));
var _upload = _interopRequireDefault(require("./Images/upload.svg"));
var _change = _interopRequireDefault(require("./Images/change.svg"));
var _accessFeatures = _interopRequireDefault(require("./Images/accessFeatures.svg"));
var _doubletick = _interopRequireDefault(require("./Images/doubletick.svg"));
var _lock = _interopRequireDefault(require("./Images/lock.svg"));
var _formbuilderpage = _interopRequireDefault(require("./Images/formbuilderpage1.png"));
var _next = _interopRequireDefault(require("./Images/next.svg"));
var _moreinfoicon = _interopRequireDefault(require("./Images/moreinfoicon.svg"));
var _cardTooltip = _interopRequireDefault(require("./Images/cardTooltip.svg"));
var _formsIcon = _interopRequireDefault(require("./Images/formsIcon.svg"));
var _settings = _interopRequireDefault(require("./Images/settings.svg"));
var _moreOptions = _interopRequireDefault(require("./Images/moreOptions.svg"));
var _profile = _interopRequireDefault(require("./Images/profile.svg"));
var _signOut = _interopRequireDefault(require("./Images/sign-out.svg"));
var _slide = _interopRequireDefault(require("./Images/slide-1.svg"));
var _slide2 = _interopRequireDefault(require("./Images/slide-2.svg"));
var _slide3 = _interopRequireDefault(require("./Images/slide-3.svg"));
var _slide4 = _interopRequireDefault(require("./Images/slide-4.svg"));
var _inActiveRating = _interopRequireDefault(require("./Images/inActiveRating.svg"));
var _activeRating = _interopRequireDefault(require("./Images/activeRating.svg"));
var _clock = _interopRequireDefault(require("./Images/clock.svg"));
var _xIcon = _interopRequireDefault(require("./Images/xIcon.svg"));
var _chipClose = _interopRequireDefault(require("./Images/chip-close.svg"));
var _fileUploadIcon = _interopRequireDefault(require("./Images/file-upload-icon.svg"));
var _chevDown = _interopRequireDefault(require("./Images/chevDown.svg"));
var _chevUp = _interopRequireDefault(require("./Images/chevUp.svg"));
var _sortDown = _interopRequireDefault(require("./Images/sort-down.svg"));
var _sortUp = _interopRequireDefault(require("./Images/sort-up.svg"));
var _tableHeadMod = _interopRequireDefault(require("./Images/table-head-mod.svg"));
var _tableMore = _interopRequireDefault(require("./Images/table-more.svg"));
var _searchIcon = _interopRequireDefault(require("./Images/search-icon.svg"));
var _viewMoreTab = _interopRequireDefault(require("./Images/view-more-tab.svg"));
var _pdf = _interopRequireDefault(require("./Images/pdf.svg"));
var _excel = _interopRequireDefault(require("./Images/excel.svg"));
var _world = _interopRequireDefault(require("./Images/world.svg"));
var _images = _interopRequireDefault(require("./Images/images.svg"));
var _powerpoint = _interopRequireDefault(require("./Images/powerpoint.svg"));
var _cancel = _interopRequireDefault(require("./Images/cancel.svg"));
var _plusIcon = _interopRequireDefault(require("./Images/plusIcon.svg"));
var _minusIcon = _interopRequireDefault(require("./Images/minusIcon.svg"));
var _plusCircle = _interopRequireDefault(require("./Images/plus-circle.svg"));
var _filterIcon = _interopRequireDefault(require("./Images/filter-icon.svg"));
var _filterLineIcon = _interopRequireDefault(require("./Images/filter-line-icon.svg"));
var _csv = _interopRequireDefault(require("./Images/csv.svg"));
var _successIcon = _interopRequireDefault(require("./Images/successIcon.svg"));
var _download = _interopRequireDefault(require("./Images/download.svg"));
var _info = _interopRequireDefault(require("./Images/info.svg"));
var _minusCircle = _interopRequireDefault(require("./Images/minus-circle.svg"));
var _searchData = _interopRequireDefault(require("./Images/searchData.svg"));
var _bellNotifications = _interopRequireDefault(require("./Images/bell-notifications.svg"));
var _newDownload = _interopRequireDefault(require("./Images/newDownload.svg"));
var _statusCircal = _interopRequireDefault(require("./Images/statusCircal.svg"));
var _kanbanNodata = _interopRequireDefault(require("./Images/kanbanNodata.svg"));
var _emptyNotification = _interopRequireDefault(require("./Images/emptyNotification.svg"));
var _playIcon = _interopRequireDefault(require("./Images/playIcon.svg"));
var _pauseIcon = _interopRequireDefault(require("./Images/pauseIcon.svg"));
var _collapseFolder = _interopRequireDefault(require("./Images/collapseFolder.svg"));
var _expandFolder = _interopRequireDefault(require("./Images/expandFolder.svg"));
var _folderPlus = _interopRequireDefault(require("./Images/folderPlus.svg"));
var _page = _interopRequireDefault(require("./Images/page.svg"));
var _editData = _interopRequireDefault(require("./Images/editData.svg"));
var _component = _interopRequireDefault(require("./Images/component.svg"));
var _rightIcon = _interopRequireDefault(require("./Images/rightIcon.svg"));
var _down = _interopRequireDefault(require("./Images/down.svg"));
var _uploadProfile = _interopRequireDefault(require("./Images/uploadProfile.svg"));
var _eyeIcon = _interopRequireDefault(require("./Images/eyeIcon.svg"));
var _edit = _interopRequireDefault(require("./Images/edit.svg"));
var _delete = _interopRequireDefault(require("./Images/delete.svg"));
var _createRole = _interopRequireDefault(require("./Images/createRole.svg"));
var _Avatar = _interopRequireDefault(require("./Images/Avatar.png"));
var _avatar = _interopRequireDefault(require("./Images/avatar.svg"));
var _selected = _interopRequireDefault(require("./Images/selected.svg"));
var _nouserInApplication = _interopRequireDefault(require("./Images/nouserInApplication.svg"));
var _rightArrow = _interopRequireDefault(require("./Images/rightArrow.svg"));
var _formIcon = _interopRequireDefault(require("./Images/formIcon.svg"));
var _pageIcon = _interopRequireDefault(require("./Images/pageIcon.svg"));
var _sectionIcon = _interopRequireDefault(require("./Images/sectionIcon.svg"));
var _fieldIcon = _interopRequireDefault(require("./Images/fieldIcon.svg"));
var _greenAddIcon = _interopRequireDefault(require("./Images/greenAddIcon.svg"));
var _redMinusIcon = _interopRequireDefault(require("./Images/redMinusIcon.svg"));
var _datePicker = _interopRequireDefault(require("./Images/datePicker.svg"));
var _resetIcon = _interopRequireDefault(require("./Images/resetIcon.svg"));
var _RedLockIcon = _interopRequireDefault(require("./Images/RedLockIcon.svg"));
var _keyboardIcon = _interopRequireDefault(require("./Images/keyboardIcon.svg"));
var _menu_icon = _interopRequireDefault(require("./Images/menu_icon.svg"));
var _TimerClock = _interopRequireDefault(require("./Images/TimerClock.svg"));
var _Pause = _interopRequireDefault(require("./Images/Pause.svg"));
var _Frame2 = _interopRequireDefault(require("./Images/Frame 26080283 (2).svg"));
var _Betastatus = _interopRequireDefault(require("./Images/Betastatus.svg"));
var _DetailsIcon = _interopRequireDefault(require("./Images/DetailsIcon.svg"));
var _lucide_lock = _interopRequireDefault(require("./Images/lucide_lock.svg"));
var _majesticons_dataLine = _interopRequireDefault(require("./Images/majesticons_data-line.svg"));
var _updatesIcon = _interopRequireDefault(require("./Images/updatesIcon.svg"));
var _feedback = _interopRequireDefault(require("./Images/feedback.svg"));
var _supportIcon = _interopRequireDefault(require("./Images/supportIcon.svg"));
var _mdi_thunderOutline = _interopRequireDefault(require("./Images/mdi_thunder-outline.svg"));
var _tableIcon = _interopRequireDefault(require("./Images/tableIcon.svg"));
var _KanbanIcon = _interopRequireDefault(require("./Images/KanbanIcon.svg"));
var _heart = _interopRequireDefault(require("./Images/heart.svg"));
var _saveRightIcon = _interopRequireDefault(require("./Images/saveRightIcon.svg"));
var _imageTypeIcon = _interopRequireDefault(require("./Images/imageType-icon.svg"));
var _pdfTypeIcon = _interopRequireDefault(require("./Images/pdfType-icon.svg"));
var _wordTypeIcon = _interopRequireDefault(require("./Images/wordType-icon.svg"));
var _pptTypeIcon = _interopRequireDefault(require("./Images/pptType-icon.svg"));
var _excelTypeIcon = _interopRequireDefault(require("./Images/excelType-icon.svg"));
var _downloadTypeIcon = _interopRequireDefault(require("./Images/downloadType-icon.svg"));